import React, { FC, useState, useEffect } from "react";
import { RouterParamType } from "@/model/navModel";
import { FormBox } from "./FormBox"


export const RelatedPerson: FC<RouterParamType> = (detailsInfo) => {
    return (
        <>
            <FormBox {...detailsInfo} />
        </>
    )
}